import { useState, useEffect } from "react";

const FeedbackForm = ({ isOpen, onClose }) => {
  const [submitted, setSubmitted] = useState(false);
  const [feedback, setFeedback] = useState({
    experience: "",
    clarity: "",
    relevance: "",
    interactive: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFeedback({ ...feedback, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Feedback submitted:", feedback);
    setSubmitted(true);

    setTimeout(() => {
      setSubmitted(false);
      onClose();
    }, 3000); // Close modal after 3 seconds
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-80 z-50">
      <div className="bg-gradient-to-b from-[#fff]  to-[#0037FFBF] rounded-lg shadow-lg w-11/12 max-w-md p-6 transform transition-all duration-300 scale-100">
        {submitted ? (
          <div className="text-center">
            <h2 className="text-lg font-semibold">Thanks for your feedback!</h2>
            <p className="text-gray-600">
              Your feedback helps us improve future chapters. Thank you!
            </p>
          </div>
        ) : (
          <>
            <h2 className="text-xl font-semibold mb-2">We value your feedback!</h2>
            <p className="text-gray-600 mb-4">
              Help us improve your experience by sharing your thoughts.
            </p>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Experience Rating */}
              <div>
                <label className="block font-medium">How would you rate your overall experience with this chapter?</label>
                <input
                  type="number"
                  name="experience"
                  min="1"
                  max="5"
                  className="mt-1 w-full border rounded p-2"
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Clarity */}
              <div>
                <label className="block font-medium">Was the information in this chapter clear and easy to understand?</label>
                <div className="flex gap-3 mt-1">
                  {["Yes", "Somewhat", "No"].map((option) => (
                    <label key={option} className="flex items-center">
                      <input
                        type="radio"
                        name="clarity"
                        value={option}
                        className="mr-2"
                        onChange={handleChange}
                        required
                      />
                      {option}
                    </label>
                  ))}
                </div>
              </div>

              {/* Relevance */}
              <div>
                <label className="block font-medium">How relevant was this chapter to your work or learning needs?</label>
                <div className="flex gap-3 mt-1">
                  {["Very relevant", "Somewhat relevant", "Not relevant"].map((option) => (
                    <label key={option} className="flex items-center">
                      <input
                        type="radio"
                        name="relevance"
                        value={option}
                        className="mr-2"
                        onChange={handleChange}
                        required
                      />
                      {option}
                    </label>
                  ))}
                </div>
              </div>

              {/* Interactive Elements */}
              <div>
                <label className="block font-medium">Did the interactive elements (e.g., Q&A game) enhance your learning experience?</label>
                <div className="flex gap-3 mt-1">
                  {["Yes", "No"].map((option) => (
                    <label key={option} className="flex items-center">
                      <input
                        type="radio"
                        name="interactive"
                        value={option}
                        className="mr-2"
                        onChange={handleChange}
                        required
                      />
                      {option}
                    </label>
                  ))}
                </div>
              </div>

              {/* Submit Button */}
              <div className="flex justify-end gap-3 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Submit
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default FeedbackForm;
